import React from 'react';

type Props = {
  color?: string;
  width?: number;
  height?: number;
};

export const BatchCallIcon: React.FC<Props> = ({
  color = '#606C77',
  width = 24,
  height = 24,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Batch Calls">
      <path
        id="Vector"
        d="M17.2632 2H6.73684C4.12632 2 2 4.12632 2 6.73684V17.2632C2 19.8737 4.12632 22 6.73684 22H17.2632C19.8737 22 22 19.8737 22 17.2632V6.73684C22 4.12632 19.8737 2 17.2632 2ZM20.8211 17.2632C20.8211 19.2211 19.2211 20.8211 17.2632 20.8211H6.73684C4.77895 20.8211 3.17895 19.2211 3.17895 17.2632V6.73684C3.17895 4.77895 4.77895 3.17895 6.73684 3.17895H17.2632C19.2211 3.17895 20.8211 4.77895 20.8211 6.73684V17.2632Z"
        fill={color}
      />
      <path
        id="Vector_2"
        d="M17.2512 14.3404L15.6155 13.0426C15.2756 12.766 14.8295 12.617 14.3833 12.617C13.8098 12.617 13.2574 12.8723 12.875 13.3191C12.7901 13.4255 12.7051 13.5106 12.6414 13.5745C12.4289 13.4468 12.0253 13.1702 11.4305 12.5532C10.8356 11.9574 10.5595 11.5532 10.4108 11.3404C10.4745 11.2766 10.5595 11.2128 10.6657 11.1064C11.473 10.4043 11.6004 9.21277 10.9206 8.38298L9.62476 6.74468C9.24238 6.2766 8.69004 6 8.07397 6C7.79781 6 7.54288 6.06383 7.28796 6.17021C6.75687 6.40426 6.16205 6.78723 5.82215 7.14894C4.10141 8.87234 5.1636 12.6596 8.24392 15.7447C10.2833 17.7447 12.7263 19 14.6383 19C15.5517 19 16.3165 18.7021 16.8688 18.1702C17.23 17.8085 17.6124 17.234 17.8461 16.7021C18.1859 15.8511 17.9523 14.8936 17.2512 14.3404ZM16.7626 16.2128C16.5714 16.6596 16.2528 17.1064 16.0403 17.3191C15.7217 17.6383 15.2331 17.8085 14.6383 17.8085C13.13 17.8085 10.9844 16.766 9.11491 14.8936C6.54443 12.3191 5.52474 9.17021 6.71438 7.97872C6.92682 7.76596 7.37293 7.44681 7.81905 7.25532C7.92527 7.21277 8.03149 7.19149 8.13771 7.19149C8.37139 7.19149 8.60507 7.29787 8.75377 7.48936L10.0496 9.12766C10.3046 9.46809 10.2621 9.95745 9.94342 10.234C9.60352 10.5319 9.39108 10.7234 9.32735 10.7872C8.83875 11.2766 9.53979 12.3404 10.6232 13.4255C11.473 14.2766 12.2802 14.8936 12.8538 14.8936C13.0025 14.8936 13.1512 14.8511 13.2574 14.7234C13.3212 14.6596 13.5123 14.4468 13.8098 14.1064C13.9585 13.9149 14.1921 13.8298 14.4046 13.8298C14.5745 13.8298 14.7445 13.8936 14.8932 14L16.5289 15.2979C16.8051 15.4894 16.8901 15.8723 16.7626 16.2128Z"
        fill={color}
      />
      <path
        id="Vector_3"
        d="M13.6686 11C13.8343 11 14 10.9286 14.142 10.8095L16.6746 8.2619V9.09524C16.6746 9.45238 16.9586 9.76191 17.3373 9.76191C17.716 9.76191 18 9.47619 18 9.09524V6.66667C18 6.30952 17.716 6 17.3373 6H14.8994C14.5444 6 14.2367 6.28571 14.2367 6.66667C14.2367 7.04762 14.5207 7.33333 14.8994 7.33333H15.7278L13.1953 9.85714C12.9349 10.119 12.9349 10.5238 13.1953 10.7857C13.3373 10.9286 13.503 11 13.6686 11Z"
        fill={color}
      />
    </g>
  </svg>
);
